export const calcularTotalItemConIva = (item) => {
  const alicuota = Number(item?.alicuota) || 0
  return calcularTotalItemSinIva(item) * (1 + alicuota / 100)
}

export const calcularTotalItemSinIva = (item) => {
  let precioUnitario = Number(item.precioUnitario) || 0

  if (
    item.preciosMayoristas &&
    item.preciosMayoristas.length > 0 &&
    item.preciosMayoristas[0].cantidad > 0
  ) {
    const preciosOrdenados = item.preciosMayoristas.sort(
      (a, b) => b.cantidad - a.cantidad
    )

    const precioMayorista = preciosOrdenados.find((p) => item.cantidad >= p.cantidad)

    if (precioMayorista) {
      precioUnitario = Number(precioMayorista.precioUnitario) || 0
    }
  }

  const porcDcto = Number(item.porcDcto) || 0
  const factorDescuento = porcDcto > 0 && porcDcto < 100 ? 1 - porcDcto / 100 : 1
  const precioConDescuento = precioUnitario * factorDescuento

  const cantidad = Number(item.cantidad) || 1
  const resultado = precioConDescuento * cantidad

  return resultado
}
